<template>
  <div class="d-flex align-items-start">
    <SelectBox
      v-model="commissionData.technician.technician_id"
      :options="technicians"
      placeholder="Select Technician"
      class="tech-select mr-3"
      name="technician_id"
      :label="index === 0 ? 'Technician' : ''"
      :validation-errors="v$.$errors"
      data-vv-as="Technician"
    />
    <TextField
      v-model="commissionData.description"
      :label="index === 0 ? 'Description' : ''"
      :no-label="index > 0"
      placeholder="Description"
      labelClass="flex-1 mr-3"
    />
    <ButtonToggle
      v-model="commissionData.amountType"
      :options="amountTypes"
      class="mr-2"
      :class="{ 'top-offset': index === 0 }"
    />
    <TextField
      v-if="commissionData.amountType === 'percent'"
      key="percent-input"
      v-model="commissionData.percentage"
      :label="index === 0 ? 'Quantity' : ''"
      percent
      labelClass="percent-input"
      :validation-errors="v$.$errors"
      name="percentage"
      :no-label="index > 0"
      data-vv-as="Percentage"
      placeholder="0%"
    />
    <TextField
      v-else
      key="dollars-input"
      v-model="commissionData.fixed_amount_cents"
      :label="index === 0 ? 'Quantity' : ''"
      currency
      labelClass="percent-input"
      :validation-errors="v$.$errors"
      name="fixed_amount_cents"
      :no-label="index > 0"
      data-vv-as="Amount"
      placeholder="$0"
    />
    <i
      class="fas fa-trash-alt ml-3 link trash-icon"
      :class="{ 'top-margin': index > 0 }"
      @click="$emit('delete-commission', commission)"
    ></i>
  </div>
</template>

<script>
import ButtonToggle from "@/components/ButtonToggle.vue";
import SelectBox from "@/components/SelectBox.vue";
import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

export default {
  components: {
    SelectBox,
    TextField,
    ButtonToggle
  },
  inject: ["$validator"],
  props: {
    commission: {
      type: Object,
      default: () => ({})
    },
    technicians: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  emits: ["delete-commission", "update-commission"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      commissionData: { ...this.commission },
      amountTypes: [
        {
          label: "%",
          value: "percent"
        },
        {
          label: "$",
          value: "dollars"
        }
      ]
    };
  },
  watch: {
    commissionData: {
      handler(val) {
        this.$emit("update-commission", { ...val });
      },
      deep: true,
      immediate: true
    },
    "commissionData.amountType"(newType) {
      if (newType === "dollars") {
        delete this.commissionData.percentage;
        this.commissionData.fixed_amount_cents =
          this.commissionData.fixed_amount_cents ?? 0;
      } else if (newType === "percent") {
        delete this.commissionData.fixed_amount_cents;
        this.commissionData.percentage = this.commissionData.percentage ?? null;
      }
    }
  },
  validations() {
    return {
      commissionData: {
        technician: {
          technician_id: { required, $autoDirty: true }
        },
        percentage: {
          required: helpers.withMessage("Percentage is required.", (value) => {
            return this.commissionData.amountType !== "percent" || !!value;
          }),
          percentageValidate: helpers.withMessage(
            "Must be between 1 and 100.",
            (value) => {
              if (this.commissionData.amountType !== "percent") return true;
              const pct = parseFloat(value) * 100;
              return pct > 0 && pct <= 100;
            }
          ),
          $autoDirty: true
        },
        fixed_amount_cents: {
          required: helpers.withMessage("Amount is required.", (value) => {
            return (
              this.commissionData.amountType !== "dollars" ||
              (value !== null && value !== undefined && value !== "")
            );
          }),
          $autoDirty: true
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.trash-icon {
  font-size: 1.2rem;
  margin-top: 1.7rem;
}

.percent-input {
  width: 90px !important;
}

.tech-select {
  width: 150px;
}
.top-margin {
  margin-top: 0.6rem;
}
.top-offset {
  margin-top: 1.3rem !important;
}

.toggle-item {
  padding: 0 14px;
}
</style>
